module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "bold margin-b0 margin-t30"
  }, [_vm._v("PLANOS")]), _vm._v(" "), _c('p', [_vm._v("Temos dois planos, com certeza um deles é ideal para você, é só escolher:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-md-6 small-padding-right"
  }, [_c('div', {
    staticClass: "second-col-box margin-b10"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-t25"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll"
    }],
    staticClass: "make-link",
    attrs: {
      "href": "#b2c-recharge"
    }
  }, [_vm._v("\n                          Veja Nossas Taxas de Recarga\n                        ")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(21)
      }
    }
  }, [_vm._v("\n                          Quero este plano!\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small-padding-left"
  }, [_c('div', {
    staticClass: "third-col-box margin-b10"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "height-72 padding-t25"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll"
    }],
    staticClass: "make-link",
    attrs: {
      "href": "#b2b-recharge"
    }
  }, [_vm._v("\n                          Veja Nossas Taxas de Recarga\n                        ")])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row-button border-radius-bottom"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": function($event) {
        return _vm.choose(31)
      }
    }
  }, [_vm._v("\n                          Quero este plano!\n                        ")])])])])])])])])])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "choose-plan"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("\n          Para Você\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("\n          Para Sua Empresa\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('h3', {
    staticClass: "sub-title plan upper no-margin margin-b10"
  }, [_vm._v("Pré-pago Manual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100 padding-s10 padding-28"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("Para quem deseja ter controle total sobre os custos e as recargas.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Excelente para você que quer ter controle total dos seus gastos e tem tempo para planejar as suas recargas.")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100 padding-14"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Adesão")]), _vm._v(" "), _c('h4', [_vm._v("R$ 39,90")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-20"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-72 border-radius-top"
  }, [_c('h3', {
    staticClass: "sub-title plan upper no-margin margin-b10",
    staticStyle: {
      "line-height": "0",
      "margin-top": "26px"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("Pré-pago com recarga manual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100 padding-s10 padding-28"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("A quem se destina?")]), _vm._v(" "), _c('p', [_vm._v("Empresas que querem controle total dos seus gastos e querem planejar as recargas.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-112 height-72-big padding-18"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Como funciona?")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n                          O próprio cliente efetua a recarga, escolhendo um dos valores disponíveis ou qualquer valor acima de R$ 2.000,00*."), _c('br'), _vm._v("\n                          Sem taxa de mensalidade. Créditos não expiram. Sem caução."), _c('br'), _vm._v("\n                          Saldo compartilhado por todos os veículos."), _c('br'), _vm._v("\n                          Disponível no app e no site.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100 padding-14"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Adesão")]), _vm._v(" "), _c('h4', [_vm._v("R$ 39,90")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-82 padding-20"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Formas de Pagamento")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cartão de Crédito")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "b2c-recharge"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "rechargeB2C"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Recargas plano pré-pago manual")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas, verifique os valores:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-red"
  }, [_c('div', {
    staticClass: "recharge-value-red"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-red"
  }, [_vm._v("50")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("5,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-yellow"
  }, [_c('div', {
    staticClass: "recharge-value-yellow"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-yellow"
  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("9,40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-green"
  }, [_c('div', {
    staticClass: "recharge-value-green"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-green"
  }, [_vm._v("150")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("13,20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-blue"
  }, [_c('div', {
    staticClass: "recharge-value-blue"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-blue"
  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("16,40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge-last"
  }, [_c('div', {
    staticClass: "recharge-purple"
  }, [_c('div', {
    staticClass: "recharge-value-purple"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-purple"
  }, [_vm._v("250")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("19,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-red"
  }, [_c('div', {
    staticClass: "recharge-value-red"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-red"
  }, [_vm._v("300")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("21,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-yellow"
  }, [_c('div', {
    staticClass: "recharge-value-yellow"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-yellow"
  }, [_vm._v("350")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("22,40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-green"
  }, [_c('div', {
    staticClass: "recharge-value-green"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-green"
  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("22,40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-blue"
  }, [_c('div', {
    staticClass: "recharge-value-blue"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-blue"
  }, [_vm._v("450")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("21,60")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge-last"
  }, [_c('div', {
    staticClass: "recharge-purple"
  }, [_c('div', {
    staticClass: "recharge-value-purple"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-purple"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("20,00")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "b2b-recharge"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "rechargeB2B"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Recargas plano controle")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas, verifique os valores:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-red"
  }, [_c('div', {
    staticClass: "recharge-value-red"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-red"
  }, [_vm._v("500")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("40,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-yellow"
  }, [_c('div', {
    staticClass: "recharge-value-yellow"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-yellow"
  }, [_vm._v("1000")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("70,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-green"
  }, [_c('div', {
    staticClass: "recharge-value-green"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-green"
  }, [_vm._v("1500")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("90,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge"
  }, [_c('div', {
    staticClass: "recharge-blue"
  }, [_c('div', {
    staticClass: "recharge-value-blue"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-blue"
  }, [_vm._v("2000")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("100,00")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-recharge-last"
  }, [_c('div', {
    staticClass: "recharge-purple"
  }, [_c('div', {
    staticClass: "recharge-value-purple"
  }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-label-purple"
  }, [_vm._v("2000+")]), _vm._v(" "), _c('div', {
    staticClass: "recharge-tax-label"
  }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v("5%")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-151b2098!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/services-senff.vue
// module id = 2050
// module chunks = 1